import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Base64Report } from '../models/report';
import { Document } from '../models/incident';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  
  apiUrl = 'v1/reports/';

  constructor(private http: HttpClient) { }

  public generateProofOfWorkReport(incidentId: number) {
    return this.http.get<Base64Report>(environment.apiUrl + this.apiUrl + 'proof-of-work/' + incidentId)
  }

  public generateQuotePDF(quoteId: number) {
    return this.http.get<Base64Report>(environment.apiUrl + this.apiUrl + 'quote/' + quoteId)
  }

  public getInvoicePDFWithQuoteId(quoteId: number) {
    return this.http.get<Document>(environment.apiUrl + this.apiUrl + 'invoice/quote/' + quoteId)
  }

  public exportIncidentsToExcel() {
    return this.http.get<Base64Report>(environment.apiUrl + this.apiUrl + 'export/incidents');
  }


}
